import { getListingPage } from "@utils/call-api/listing-pages-call";
import { getHub } from "@utils/call-api/hubs-call";

export const getListingPageInformation = async (listingSlug, locale) => {
  const resListingPage = await getListingPage(listingSlug, locale);
  const listingPage = resListingPage.data;

  if (!listingPage?.hub?.context) {
    const currentHubSlug = listingPage.breadcrumbs[0].slug;
    const resHub = await getHub(currentHubSlug, locale);
    const hub = resHub.data;
    listingPage.hub = hub;
  }

  return listingPage;
};
